import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const usePeriodPickerTranslations = () => {
    const { t } = useTranslation('common');

    const translations = useMemo(
        () => ({
            months: [
                t('months.0'),
                t('months.1'),
                t('months.2'),
                t('months.3'),
                t('months.4'),
                t('months.5'),
                t('months.6'),
                t('months.7'),
                t('months.8'),
                t('months.9'),
                t('months.10'),
                t('months.11'),
            ],
            shortMonths: [
                t('shortMonths.0'),
                t('shortMonths.1'),
                t('shortMonths.2'),
                t('shortMonths.3'),
                t('shortMonths.4'),
                t('shortMonths.5'),
                t('shortMonths.6'),
                t('shortMonths.7'),
                t('shortMonths.8'),
                t('shortMonths.9'),
                t('shortMonths.10'),
                t('shortMonths.11'),
            ],
            days: [t('days.0'), t('days.1'), t('days.2'), t('days.3'), t('days.4'), t('days.5'), t('days.6')],
            shortDays: [t('shortDays.0'), t('shortDays.1'), t('shortDays.2'), t('shortDays.3'), t('shortDays.4'), t('shortDays.5'), t('shortDays.6')],
            goToToday: t('goToToday'),
            weekNumberFormatString: t('weekNumberFormatString'),
            prevMonthAriaLabel: t('prevMonthAriaLabel'),
            nextMonthAriaLabel: t('nextMonthAriaLabel'),
            prevYearAriaLabel: t('prevYearAriaLabel'),
            nextYearAriaLabel: t('nextYearAriaLabel'),
            prevYearRangeAriaLabel: t('prevYearRangeAriaLabel'),
            nextYearRangeAriaLabel: t('nextYearRangeAriaLabel'),
            closeButtonAriaLabel: t('closeButtonAriaLabel'),
        }),
        [t],
    );

    return translations;
};
